import { Rarity } from '#src/__generated__/globalTypes.ts';
import { useSeriesNav } from '#src/hooks/commonGame/useSeriesNav.ts';
import { LIFECYCLE, useLifecycle } from '#src/hooks/useLifecycle.ts';
import { isSupportedCardSet } from '#src/lib/cardSets.tsx';
import type { SupportedCardSet } from '#src/lib/cardSets.tsx';
import { isRarityStr } from '#src/lib/so5.ts';

export const usePinnedShardRarity = () => {
  const seriesNav = useSeriesNav();
  const { lifecycle, update: updateLifecycle } = useLifecycle();
  const [rarity, cardSet] =
    typeof lifecycle?.pinnedShardRarity === 'string'
      ? lifecycle.pinnedShardRarity.split(':')
      : [];

  // force pinned rarity to common winter if series nav is active
  const finalRarity = seriesNav ? Rarity.common : rarity;
  let finalCardSet = seriesNav ? 'winter' : cardSet;

  // default to common-base-set to support old pinned shard rarity with "common" as value
  if (finalRarity === Rarity.common && !finalCardSet) {
    finalCardSet = 'common-base-set';
  }

  return {
    pinnedShardRarity: isRarityStr(finalRarity) ? finalRarity : undefined,
    pinnedShardCardSet: isSupportedCardSet(finalCardSet)
      ? finalCardSet
      : undefined,
    updatePinnedShardRarity: (
      inputRarity: Rarity,
      inputCardSet: Nullable<SupportedCardSet>
    ) => {
      const value = `${inputRarity}${inputCardSet ? `:${inputCardSet}` : ''}`;
      updateLifecycle(
        LIFECYCLE.pinnedShardRarity,
        lifecycle?.[LIFECYCLE.pinnedShardRarity] === value ? false : value
      );
    },
  };
};
